module.exports = __webpack_public_path__ + "assets/img/portfolio-hero.0e711d60.jpg";